import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable } from 'components/basic'
import { HttpFilter } from 'projects/flow-gui-access/components/core'
import FlowView from 'components/core/FlowView'
import ReactHtmlParser from 'react-html-parser'
import { date } from 'helpers'
import http from 'API/http'
import UUID from 'uuid/v4'

const tableHeaders = [
  {
    title: 'ID',
    key: 'ticketNumber'
  },
  {
    title: 'Title',
    key: 'subject'
  },
  {
    title: 'Reference',
    key: 'reference'
  },
  {
    title: 'Created',
    key: 'created'
  },
  {
    title: 'Last Update',
    key: 'updated'
  },
  {
    title: 'Status',
    key: 'status'
  },
  {
    title: 'Assigned To',
    key: 'assignee'
  }
]
class TicketOverview23 extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      searching: true,
      searchQuery: '',
      tickets: [],
      modalState: false,
      loading: true,
      conditions: null,
      sortingOrder: 'DESC',
      sortingValue: 'updated'
    }
  }
  async componentDidMount () {
    if (this.props.access !== 'FLOW') {
      this.getTicketsNetadmin()
    } else {
      this.getTicketsFlow()
      this.getOrderFromDeepstream()
    }
  }

  async getOrderFromDeepstream () {
    //eslint-disable-next-line
    var [err, order] = await http.get('2.3/deepstream/record/ticket_overview_order')
    if (order.data !== undefined && Object.keys(order.data).length) {
      order = JSON.parse(order.data.order)
      this.setState({sortingOrder: order.sortingOrder, sortingValue: order.sortingValue}, this.getTicketsFlow)
    }
  }
  conditionsToQuerystring () {
    var keyValue = {}
    if (this.state.conditions) {
      this.state.conditions.subgroups.map(subgroup => subgroup.items.map(item => {
        //eslint-disable-next-line
        if (keyValue[item.key]) return keyValue[item.key] = keyValue[item.key] + ',' + item.value
        keyValue[item.key] = item.value
      }))
    }
    keyValue['sortingBy'] = this.state.sortingValue
    keyValue['sortingOrder'] = this.state.sortingOrder
    return Object.keys(keyValue).map(key => key + '=' + keyValue[key]).join('&')
  }
  async getTicketsFlow () {
    var err, res
    [err, res] = await http.get('2.3/tickets/search/' + this.state.searchQuery + '?' + this.conditionsToQuerystring())
    if (err) return this.setState({tickets: [], searching: false})
    this.setState({tickets: res.data, searching: false})
  }
  async getTicketsNetadmin () {
    var err, res
    [err, res] = await http.get('2.3/tickets/search/' + this.state.searchQuery)
    if (err) return this.setState({tickets: [], searching: false})
    this.setState({tickets: res.data, searching: false, loading: false})
  }
  async sortBy (column) {
    let sortingOrder = this.state.sortingOrder
    if (column === this.state.sortingValue) {
      sortingOrder = (this.state.sortingOrder === 'DESC' ? 'ASC' : 'DESC')
    } else {
      sortingOrder = 'DESC'
    }
    await http.post('2.3/deepstream/record/ticket_overview_order', {
      key: 'order',
      value: JSON.stringify({
        sortingOrder: sortingOrder,
        sortingValue: column
      })
    })
    this.setState({sortingValue: column, sortingOrder: sortingOrder, activePage: 1}, this.getTicketsFlow)
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }
  getAssignee (assignee) {
    switch (assignee) {
      case 0:
        return 'CO'
      case 1:
        return 'SP'
      default:
        return assignee
    }
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Trouble Tickets' subtitle='Overview' />
        <hr />
        <div className='row'>
          {this.props.access === 'FLOW' && <HttpFilter endpoint='2.3/deepstream/record/' identifier='ticket_overview_filter' callback={conditions => this.setState({conditions: conditions, activePage: 1}, e => this.getTicketsFlow())} filters={[
            {type: 'select', operator: 'EQUAL', key: 'status', name: 'Filter by status', toggles: [{value: 'Open', name: 'Open'}, {value: 'Closed', name: 'Closed'}, {value: 'New', name: 'New'}]},
            {type: 'select', operator: 'EQUAL', key: 'assignee', name: 'Filter by assigned to', toggles: [{value: 'CO', name: 'CO'}, {value: 'RP', name: 'RP'}, {value: 'SP', name: 'SP'}]}
          ]}
           />}
          <StaticBox cols={12} icon='commenting-o' title='Tickets'>
            {this.props.access !== 'FLOW' ? <FlowTable loading={this.state.searching} paginatable={20} data={this.state.tickets.map(res => [{ onClick: e => (window.location.href = '/#/ticket/' + res.ticketRef) }, <a href={'/#/ticket/' + res.ticketRef} className='table-link'><i className='fa fa-folder-open-o' /></a>, res.ticketRef, ReactHtmlParser(res.title), res.spReference, date.format(res.created * 1000), date.format(res.updated * 1000), this.getStatus(res.state.status), (res.assignee ? res.assignee : this.getAssignee(res.state.assignedTo))])}>
              <tr>
                <th className='buttons' />
                <th>ID</th>
                <th>Title</th>
                <th>Reference</th>
                <th>Created</th>
                <th>Last Update</th>
                <th>Status</th>
                <th>Assignee</th>
              </tr>
            </FlowTable> : <div>
              <FlowTable loading={this.state.searching} paginatable={20} data={this.state.tickets.map(res => [{ onClick: e => (window.location.href = '/#/ticket/' + res.ticketRef) }, <a href={'/#/ticket/' + res.ticketRef} className='table-link'><i className='fa fa-folder-open-o' /></a>, res.ticketRef, ReactHtmlParser(res.title), res.spReference, date.format(res.created * 1000), date.format(res.updated * 1000), this.getStatus(res.state.status), (res.assignee ? res.assignee : this.getAssignee(res.state.assignedTo))])}>
                <tr>
                  <th className='buttons' />
                  {tableHeaders.map(column =>
                    <th key={UUID()} onClick={e => {
                      this.sortBy(column.key)
                    }} className='clickable'>{column.title || ''} {this.state.sortingValue === column.key && (this.state.sortingOrder === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)}</th>
                  )}
                </tr>
              </FlowTable>
            </div>}
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketOverview23 = connect(state => state.siteReducer)(TicketOverview23)
export default TicketOverview23



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/ticket/overview.js